import { Alert, Badge } from "flowbite-react";
import TitleStripe from "../../common/TitleStripe";
import { formatToReal } from "../../../utils/utils";

const PORTE_RANKS = [1, 2, 3, 4, 5];

function formatAnnualValue(value) {
  if (value === null || value === undefined || value === "")
    return "Indisponível";
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return value;
  return formatToReal(numeric);
}

function FaturamentoPresumido({ data }) {
  if (!data && !data?.faturamentoPresumido) return null;

  const source = data?.faturamentoPresumido ?? data;
  const rawStatus = source?.statusRetorno ?? data?.statusRetorno;
  const statusRetorno =
    Number.isFinite(Number(rawStatus)) || rawStatus === 1
      ? Number(rawStatus)
      : null;

  if (statusRetorno !== 1) return null;

  const referenceDate = source?.dataReferencia ?? data?.dataReferencia;
  const porteKey = String(source?.porteEmpresa?.pontuacao ?? "").trim();
  const faixaKey = String(source?.faixa?.pontuacao ?? "").trim();

  const porteLabel = source?.porteEmpresa?.texto ?? "Não informado";
  const faixaLabel = source?.faixa?.texto ?? "Não informado";
  const porteNumber =
    Number.isFinite(Number(porteKey)) && porteKey !== ""
      ? Number(porteKey)
      : null;

  return (
    <div>
      <TitleStripe>💰 Faturamento Presumido</TitleStripe>
      {source?.erro?.texto ? (
        <Alert color="info" className="mt-4">
          {source?.erro?.texto}
        </Alert>
      ) : (
        <>
          {" "}
          <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between mt-4">
            <div className="flex items-center gap-2">
              <p className="text-xs uppercase tracking-wide text-slate-500">
                Referência:
              </p>
              <p className="text-xs font-semibold text-slate-900">
                {referenceDate || "Indisponível"}
              </p>
            </div>
            <div className="flex items-center gap-2">
              <p className="text-[11px] text-slate-500">
                Consulta disponível para {referenceDate || "a última data"}
              </p>
            </div>
          </div>
          <div className="w-full mx-auto mt-2 rounded-2xl">
            <div className="grid gap-4  md:grid-cols-3">
              <div className="rounded-2xl border border-emerald-200 bg-gradient-to-br from-emerald-50 to-white p-4 shadow-sm">
                <p className="text-[11px] uppercase tracking-wide text-emerald-700">
                  Faturamento presumido anual
                </p>
                <p className="mt-2 text-2xl font-bold text-emerald-900">
                  {formatAnnualValue(source?.faturamentoPresumidoAnual)}
                </p>
                <p className="text-[11px] text-slate-500 mt-2">
                  Valor informado pela base com as últimas atualizações
                </p>
              </div>

              <div className="rounded-2xl border border-sky-200 bg-gradient-to-br from-sky-50 to-white p-4 shadow-sm">
                <p className="text-[11px] uppercase tracking-wide text-sky-700">
                  Faixa de faturamento
                </p>
                <p className="mt-2 text-xl font-semibold text-sky-900">
                  {faixaLabel}
                </p>
                <p className="text-xs text-slate-500 mt-2">
                  Pontuação {faixaKey || "—"} • Usa o critério oficial do score
                </p>
              </div>

              <div className="rounded-2xl border border-indigo-200 bg-gradient-to-br from-indigo-50 to-white p-4 shadow-sm">
                <p className="text-[11px] uppercase tracking-wide text-indigo-700">
                  Porte da empresa
                </p>
                <p className="mt-2 text-xl font-semibold text-indigo-900">
                  {porteLabel}
                </p>
                <div className="grid grid-cols-5 gap-1 mt-2">
                  {PORTE_RANKS.map((rank) => (
                    <span
                      key={rank}
                      className={`block h-2 rounded-full ${
                        porteNumber && rank <= porteNumber
                          ? "bg-indigo-600"
                          : "bg-indigo-200"
                      }`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default FaturamentoPresumido;
